import { render, staticRenderFns } from "./GroupDeleteDialog.vue?vue&type=template&id=1566d644&scoped=true&"
import script from "./GroupDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./GroupDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupDeleteDialog.vue?vue&type=style&index=0&id=1566d644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566d644",
  null
  
)

export default component.exports